module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7B2KQ"))).then(() => parcelRequire('hEqeo'));